/** カンマ区切り文字列を配列に変換する */
export const parseProjectsParam = (param: string): string[] =>
  param.split(',').filter(Boolean);

/** 配列をカンマ区切り文字列に変換する（空の場合は空文字列） */
export const toProjectsParam = (ids: string[]): string =>
  ids.length > 0 ? ids.join(',') : '';
